<template>
    <div class="top-bar">
        <h1>Dashboard</h1>
        <div class="alert" v-if="global_warning.active">
            <v-icon class="notranslate">info</v-icon>
            <a :href="global_warning.link"
               target="_blank"
            >{{ global_warning.text }}</a>
        </div>
        <ToolBar/>
    </div>
</template>

<script>
import ToolBar from './ToolBar'
export default {
  name: 'TopBar',
  components: { ToolBar },
  computed: {
    global_warning: function () {
      let globalWarning = this.$store.state.user['global_warning']
      return {
        ...globalWarning
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .top-bar {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 50;
        display: block;
        height: 65px;
        clear: both;
        background: #fff;
        border-bottom: 1px solid rgba(0,0,0,0.12);

        .alert {
            position: absolute;
            height: 41px;
            line-height: 29px;
            padding: 4px 16px;
            max-width: calc(100% - 536px);
            width: auto;
            top: 12px;
            left: 50%;
            transform: translateX(-50%);
            text-align: center;
            background: #f5f5f5;
            border-radius: 4px;
            border-top: 4px solid var(--warning-color);
            .v-icon {
                line-height: inherit;
                float: left;
                margin-right: 16px;
                color: var(--warning-color);
            }
            a {
                line-height: inherit;
                font-size: 16px;
                text-decoration: none;
                color: rgba(0,0,0,0.87);
            }
        }

        h1 {
            margin: 0;
            float: left;
            display: inline-block;
            background: url("../assets/ip-logo.png") left center no-repeat;
            background-size: contain;
            height: 48px;
            line-height: 48px;
            color: rgba(0,0,0,0.72);
            font-size: 28px;
            font-weight: bold;
            padding-left: 60px;
        }
    }
    @media only screen and (max-width: 1259px) {
        .top-bar {
            padding: 8px 36px 8px 82px;
        }
    }
    @media only screen and (min-width: 1260px) {
        .top-bar {
            padding: 8px 36px;
        }
    }
</style>
